export class ModuleDataHandler {
  moduleData: any;
  numberOfDay: any;

  constructor(moduleData: any, numberOfDay: any) {
    this.moduleData = moduleData;
    this.numberOfDay = numberOfDay;
  }

  calculateOT(rowIdx: number) {
    const { total_1, sun_ot } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'ot',
      Number((+total_1 || 0) - (+sun_ot || 0))
    );
    this.calculateTotal('ot', 'total_ot');
  }
  //
  calculateDutyAmount(rowIdx: number) {
    const {
      spl_allowance = 0,
      salary = 0,
      duty = 0,
    } = this.getListData(rowIdx);

    this.updateListProperty(
      rowIdx,
      'duty_amt',
      Math.round(((+spl_allowance + +salary) * duty) / this.numberOfDay)
    );
    this.calculateTotal('duty_amt', 'total_duty_amt');
  }

  calculateOTAmount(rowIdx: number) {
    const { salary = 0, total_1 = 0 } = this.getListData(rowIdx);

    this.updateListProperty(
      rowIdx,
      'ot_amt',
      Math.round((salary * total_1) / (30 * 8))
    );
    this.calculateTotal('ot_amt', 'total_ot_amt');
  }

  calculateTotal_2(rowIdx: number) {
    const { duty_amt = 0, ot_amt = 0 } = this.getListData(rowIdx);

    this.updateListProperty(rowIdx, 'total_2', Number(duty_amt + ot_amt));
    this.calculateTotal('total_2', 'total_total_2');
  }

  calculateTotal_3(rowIdx: number) {
    const { total_2 = 0, advance = 0 } = this.getListData(rowIdx);

    this.updateListProperty(rowIdx, 'total_3', Number(total_2 - advance));
    this.calculateTotal('total_3', 'total_total_3');
  }

  calculateNetPay(rowIdx: number) {
    const {
      total_3 = 0,
      tea = 0,
      pf_esi = 0,
      cheque_payment = 0,
    } = this.getListData(rowIdx);

    this.updateListProperty(
      rowIdx,
      'net_pay',
      Number(total_3 - tea - pf_esi - cheque_payment)
    );
    this.calculateTotal('net_pay', 'total_net_pay');
  }

  calculateCashPayable(rowIdx: number) {
    const { net_pay, cheque_amount } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'cash_payable',
      Number(net_pay - cheque_amount)
    );
    this.calculateTotal('cash_payable', 'total_cash_payable');
  }
  //

  // all totals function
  calculateTotal(key_name: any, update_key_name: any) {
    const total = this.moduleData?.list?.reduce(
      (accumulator: any, currentValue: any) => {
        if (currentValue[key_name]) {
          return (+accumulator || 0) + (+currentValue[key_name] || 0);
        }
        return accumulator;
      },
      0
    );
    this.moduleData[update_key_name] = total;
  }

  handleSalaryCalc(rowIdx: number) {
    this.calculateOT(rowIdx);
    this.calculateDutyAmount(rowIdx);
    this.calculateOTAmount(rowIdx);
    this.calculateTotal_2(rowIdx);
    this.calculateTotal_3(rowIdx);
    this.calculateNetPay(rowIdx);
    this.calculateCashPayable(rowIdx);
  }

  private getListData(rowIdx: number) {
    return this.moduleData.list[rowIdx];
  }

  private updateListProperty(rowIdx: number, property: string, value: any) {
    this.moduleData.list[rowIdx][property] = value;
  }
}
